// Core
import React from 'react';

// Component
import { OptionsSwitchProps } from './OptionsSwitch.types';
import { Component } from './OptionsSwitch.style';

function OptionsSwitch({
  className,
  disabled,
  onChange,
  options,
  testId,
  value,
}: OptionsSwitchProps): JSX.Element {
  return (
    <Component
      data-testid={testId}
      className={className}
      disabled={disabled}
      options={options}
      value={value}
      onChange={onChange}
    />
  );
}

export { OptionsSwitch };
